import React from "react";
import 'date-fns';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import {Animated} from "react-animated-css";
import ReactTable from "react-table";
import Link from '@material-ui/core/Link';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MButton from '@material-ui/core/Button';
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import ButtonGroup from '@material-ui/core/ButtonGroup';
// core components
import TextField from '@material-ui/core/TextField'; 
import ReactTableRecordCount from "../../Components/ReactTableRecordCount";
import MenuItem from '@material-ui/core/MenuItem';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardText from "components/Card/CardText.js";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { withStyles } from '@material-ui/styles';
import Service from 'Utils/Service';
import Avatar from '@material-ui/core/Avatar';
import NavigateNext from "@material-ui/icons/NavigateNext";
import DateFnsUtils from '@date-io/date-fns'; 
import Moment from 'moment';
import FormControl from "@material-ui/core/FormControl";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
// import Meetingschedules from './scheduleplannerpages/Meetingschedules.js';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToPros } from '../../../Utils/MapStateDispatchProps.js';
import CheckAccess from "components/CheckAccess.js";
// import Meetingupdation from '../scheduleplannerpages/Meetingupdation.js'; 

const divStyle = {
  display: 'flex',  justifyContent:'center', alignItems:'center' // 'ms' is the only lowercase vendor prefix
};
const divStyle2 = {
  marginTop:'10px',marginBottom:'10px',display: 'flex',justifyContent:'center', alignItems:'center' // 'ms' is the only lowercase vendor prefix
};

const panelStyles = {
  panelClass: {
    zIndex:999
  },
  ModalStyle: {
    width:'100% !important',
    backgroundColor:'#ddd'
  }
};

const pageStyles = {...styles, ...panelStyles }
const useStyles = makeStyles(pageStyles);

function filterCaseInsensitive(filter, row) 
{
  const id = filter.pivotId || filter.id;
    if (row[id] !== null) {
        return (
          row[id] !== undefined ?
            String(row[id].toString().toLowerCase())
            .includes(filter.value.toString().toLowerCase()):true
        );
    }
}

class Dashboard extends React.Component 
{
  constructor(props) 
  {
    super(props);
    this.state = {
      selectType:'',
      Meetingschedules:false,
      Meetingupdation:false,
      createschedule:false, 
      tableData: [],
      NoDatatableData: [],
      EmployeeData:[],
      todays_schedule_count:0,
      upcoming_schedule_count:0,
      present_week_met_count:0,
      present_week_rescheduled_count:0,
      from_date: Moment(new Date()).format("YYYY-MM-DD"),
      to_date: Moment(new Date()).format("YYYY-MM-DD"),
      area_partner:'',
      meeting_type:'',
      submit: false,
      scheduled_meetings_count:0,
      mom_count:0,
      rescheduled_count:0,
      leads_count:0
    } 
  }

  scrollToTop(type) {
    if(type === 'close'){
      this.setState({Meetingupdation:false});
      this.setState({ viewschedule: false });
    }
    const container = document.querySelector('.slide-pane__content');  
    container.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  }; 

  handleDateChange = (date) => {
    this.setState({from_date:Moment(date).format("YYYY-MM-DD")});
  };

  handleDateChange1 = (date) => {
    this.setState({to_date:Moment(date).format("YYYY-MM-DD")});
  };

  submitFilter(){
    const postData = {
      id:this.props.data.id,
      user_id:this.props.data.user_id,
      role_id:this.props.data.role_id,
      from_date:this.state.from_date,
      to_date:this.state.to_date,
      meeting_type:this.state.meeting_type,
      area_partner:this.state.area_partner
    };
    console.log(postData);
    new Service().apiCall('SchedulePlanner/GetDayActivityData',postData).then(response =>
    {
      console.log(response.data.scheduled_meetings_count);
      if (response.data!='') 
      {                
        this.setState({scheduled_meetings_count:response.data.scheduled_meetings_count,mom_count:response.data.mom_count,rescheduled_count:response.data.rescheduled_count,leads_count:response.data.leads_count}); 
      }
      else{
        this.setState({countData:[]})
      }
    }).catch(error => {
      alert("error.response.data.message");
    });
  }

  getLeadDashboardData() {
    const postData = {
      id:this.props.data.id,
      user_id:this.props.data.user_id,
      role_id:this.props.data.role_id
    };
    new Service().apiCall('Dashboards/get_dashboard_data',postData).then(response =>
    {
      if (response.data!='') 
      {                
        this.setState({todays_schedule_count:response.data.todays_schedule_count});
        this.setState({upcoming_schedule_count:response.data.upcoming_schedule_count});
        this.setState({present_week_met_count:response.data.present_week_met_count});
        this.setState({present_week_rescheduled_count:response.data.present_week_rescheduled_count});
      }
      else{
        this.setState({countData:[]})
      }
    }).catch(error => {
      alert("error.response.data.message");
    });
  }

  getEmployeeData() {
    this.setState({EmployeeData: []});
    const postData = {
      id:this.props.data.id,
      user_id:this.props.data.user_id,
      role_id:this.props.data.role_id
    };
    new Service().apiCall('EmployeeDetails/GetAllHierarchyData',postData).then(response =>
    {
        console.log(response.data);
      if (response.status === 200 && response.data !='') {
        this.setState({ EmployeeData: response.data });      
      }else{
        this.setState({EmployeeData: []}); 
      }
    }).catch(error => {
      alert(error.response.data);
    });
  } 

  getSchedulePlannerData() {
    const postData = {
      status:'Todays',
      id:this.props.data.id,
      user_id:this.props.data.user_id,
      role_id:this.props.data.role_id
    };
    new Service().apiCall('SchedulePlanner/GetScheduleDataByStatus',postData).then(response =>
    {
      if (response.data!='') 
      {                
        this.setState({tableData:response.data});
      }
    }).catch(error => {
      this.setState({NoDatatableData: [{ id: '1', name: '',}]})
    });
  }   
  checkAccess = () => {
    return (
    <CheckAccess {...this.props} />
    )
  }

  viewScheduleDetails(id,InstituteID,InstituteName) {
    this.setState({Meetingupdation:true});
    this.setState({schedule_id:id});
    this.setState({institute_id:InstituteID});
    this.setState({institute_name:InstituteName});
   }

  componentDidMount() {
    this.getLeadDashboardData(); 
    this.getSchedulePlannerData();
    this.getEmployeeData();
  }

  renderHeader = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={10} md={6} style={{margin:'auto'}}>
          <div>Schedule</div>
        </GridItem> 
        <GridItem xs={12} sm={10} md={6} style={{textAlign:'right'}}> 
          <ButtonGroup  color="secondary" aria-label="outlined secondary button group" className="buttonGroup">
          <MButton variant={this.state.selectType == "createschedule" ?"contained":"outlined"} onClick={()=>this.setState({selectType:'createschedule'})}>Create</MButton> 
          <MButton variant={this.state.selectType == "viewschedule" ?"contained":"outlined"} onClick={()=>this.setState({selectType:'viewschedule'})}>View</MButton>
          </ButtonGroup>
        </GridItem>
      </GridContainer>
    )
  }

  render(){
  const { classes } = this.props;

  return (
    <div>
      <Animated  className="Animated" animationIn="slideInRight" animationOut="slideOutLeft" > 
        <GridContainer justify="center">
            <GridItem lg={8} md={8} sm={12} xs={12}>
                <Card >
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={6} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    autoOk={true}
                                    value={this.state.from_date}
                                    //shrink={true}
                                    id="date-picker-dialog"
                                    label="From Date"
                                    inputVariant="outlined"
                                    format="dd/MM/yyyy"
                                    onChange={this.handleDateChange}   
                                    KeyboardButtonProps={{
                                    'aria-label': 'change date', 
                                    }} 
                                    />
                                    </MuiPickersUtilsProvider>                  
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    autoOk={true}
                                    value={this.state.to_date}
                                    //shrink={true}
                                    id="date-picker-dialog"
                                    label="To Date"
                                    inputVariant="outlined"
                                    format="dd/MM/yyyy"
                                    onChange={this.handleDateChange1}   
                                    KeyboardButtonProps={{
                                    'aria-label': 'change date', 
                                    }} 
                                    />
                                    </MuiPickersUtilsProvider>                  
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3} lg={3}>
                                <FormControl fullWidth>
                                    <TextField
                                    select
                                    label="Type"
                                    options={this.state.meeting_type}
                                    onChange={(event) => this.setState({meeting_type:event.target.value})}
                                    variant="outlined">
                                    <MenuItem value='All'>All</MenuItem>
                                    <MenuItem value='Telephonic'>Telephonic</MenuItem>
                                    <MenuItem value='In Person'>In Person</MenuItem>
                                
                                    </TextField>
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3} lg={3}>
                                <FormControl className={classes.margin} fullWidth>
                                    <TextField
                                    className="m-2"
                                    id="outlined-select-currency"
                                    select
                                    label="Area Partner"
                                    options={this.state.area_partner}
                                    onChange={(event) => this.setState({area_partner:event.target.value})}
                                    variant="outlined">
                                    <MenuItem value='All'>All</MenuItem>
                                    {this.state.EmployeeData.map((element,index) => (
                                        <MenuItem key={element.user_id} name={element.user_id} index={index} id={element.user_id} value={element.user_id} >
                                            {element.name}
                                        </MenuItem>
                                    ))}
                                
                                    </TextField>
                                </FormControl>
                            </GridItem>
                        </GridContainer>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={6} md={2} lg={2}>
                                <MButton className={classes.FinalSubmitButton } onClick={() => { this.setState({submit:true});this.submitFilter()}} variant="outlined" >
                                    Submit
                                </MButton>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        {this.state.submit === true && <><GridContainer>	 
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardBody>
                <div className={classes.center} style={divStyle}>
                <a style={{color:'#000',cursor:'pointer'}}>  <h4>Leads Created</h4>
                  <h3 style={divStyle2}>{this.state.leads_count}</h3>
                </a>
                </div>
              </CardBody>
            </Card>
          </GridItem> 
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardBody>
                <div className={classes.center} style={divStyle}>
                <a style={{color:'#000',cursor:'pointer'}}>  <h4>Scheduled Meetings</h4>
                  <h3 style={divStyle2}>{this.state.scheduled_meetings_count}</h3>
                </a>
                </div>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardBody>
                <div className={classes.center} style={divStyle}>
                <a style={{color:'#000',cursor:'pointer'}}>  <h4>Total MoM Added</h4>
                  <h3 style={divStyle2}>{this.state.mom_count}</h3> 
                </a>
                </div>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardBody>
                <div className={classes.center} style={divStyle}>
                <a style={{color:'#000',cursor:'pointer'}}>  <h4>Total Rescheduled</h4>
                  <h3 style={divStyle2}>{this.state.rescheduled_count}</h3>
                </a>
                </div>
              </CardBody>
            </Card>
          </GridItem>	  
        </GridContainer>
        <GridContainer  justify="center" alignItems="center">   
            <GridItem xs={12} sm={12} md={10}>
              {/*<Card>
              <CardHeader color="warning" text>
                <CardText className='cardHeader' style={{width:'100%',textAlign:'center'}} >
                  <ButtonGroup  color="secondary" aria-label="outlined secondary button group" className="buttonGroup">
                    <MButton variant={this.state.scheduleType == "All" ?"contained":"outlined"} onClick={() => { this.setState({scheduleType:'All'});this.GetDataByStatus('All')}}>All</MButton> 
                    <MButton variant={this.state.scheduleType == "Todays" ?"contained":"outlined"} onClick={() => { this.setState({scheduleType:'Todays'});this.GetDataByStatus('Todays')}}>Created Leads</MButton>  
                    <MButton variant={this.state.scheduleType == "Past Schedules" ?"contained":"outlined"} onClick={() => { this.setState({scheduleType:'Past Schedules'});this.GetDataByStatus('Past Schedules')}}>Scheduled Meeting</MButton> 
                    <MButton variant={this.state.scheduleType == "Future Schedules" ?"contained":"outlined"} onClick={() => { this.setState({scheduleType:'Future Schedules'});this.GetDataByStatus('Future Schedules')}}>Total Met</MButton> 
                    <MButton variant={this.state.scheduleType == "MOM" ?"contained":"outlined"} onClick={() => { this.setState({scheduleType:'MOM'});this.GetDataByStatus('MOM')}}>Total Rescheduled</MButton> 
                  </ButtonGroup>
                </CardText>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={
                  this.state.tableData.map((original,key) => {
                    return ({
                      slno: key+1,
                      //lead_name: <Link href="#" onClick={()=> this.viewScheduleDetails(original.id,original.institute_id,original.institute_name)}><div style={{textAlign:'left'}}>{original.institute_name}</div></Link>,
                      lead_name: original.institute_name,
                      person_mat:original.created_by,
                      meeting_type:original.meeting_type,
                      meeting_date:original.meeting_date,
                      id:original.id,
                      institute_id:original.institute_id,
                      meeting_time_formated:original.meeting_time_formated
                    })
                  })}
                  filterable
                  minRows={0}
                  columns={[
                  {
                    Header: "S No",
                    accessor: "slno",
                    width: 70,
                    className: "center",
                    Cell : (row) => {
                      return <div>{( row.page * row.pageSize ) + row.viewIndex + 1}</div>
                    }
                    // Filter: ({filter, onChange}) => (
                    //   <input type='text' style={{textAlign:'center'}} placeholder="S No" value={filter ? filter.value : ''}  onChange={event => onChange(event.target.value)} />
                    // )
                  },
                  {
                    Header: "Lead Name",
                    accessor: "lead_name",
                    className: "center", 
                    Cell : id => { return (<Link href="#" onClick={()=> this.viewScheduleDetails(id.original.id,id.original.institute_id,id.original.lead_name)}><div style={{textAlign:'left'}}>{id.original.lead_name}</div></Link>);},
                      Filter: ({filter, onChange}) => (
                        <input type='text' style={{textAlign:'center'}} placeholder="Search Lead" value={filter ? filter.value : ''}  onChange={event => onChange(event.target.value)} />
                      )
                  },
                  {
                    Header: "AP",
                    accessor: "person_mat",
                    className: "center",
                      Filter: ({filter, onChange}) => (
                        <input type='text' style={{textAlign:'center'}} placeholder="Search AP" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)} />
                      )
                  },
                  {
                    Header: "Type",
                    accessor: "meeting_type",
                    className: "center",
                      Filter: ({filter, onChange}) => (
                        <input type='text' style={{textAlign:'center'}} placeholder="Search Type" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)} />
                      )
                  },
                  {
                    Header: "Date & Time",
                    accessor: "meeting_date",
                    className: "center",
                    Cell : id => { return (<div>{this.datefunction(id.original.meeting_date,id.original.meeting_time_formated)}</div>);},
                      Filter: ({filter, onChange}) => (
                        <input type='text' style={{textAlign:'center'}} placeholder="Search Date" value={filter ? filter.value : ''} onChange={event => onChange(event.target.value)} />
                      )
                  }
                  ]}
                  defaultFilterMethod={filterCaseInsensitive}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                  >{(state, makeTable) => { 
                    return (
                      <ReactTableRecordCount
                        state={state}
                        makeTable={makeTable}
                        totalRecords={state.sortedData.length ? state.sortedData.length : state.resolvedData.length   }
                      />
                    ); 
                  }}</ReactTable> 
              </CardBody>
            </Card>*/}
          </GridItem>
        </GridContainer></> }

      </Animated>	 

    </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToPros)(withStyles(pageStyles)(Dashboard)); 
